/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedSearchSuggestions_itemSearch$ref = any;
export type SbSharedSearchSuggestions_itemSearch = {
    readonly pageType: string | null;
    readonly spellCheck: {
        readonly suggestions: ReadonlyArray<{
            readonly name: string | null;
            readonly count: number | null;
            readonly uri: string | null;
        } | null> | null;
    } | null;
    readonly " $refType": SbSharedSearchSuggestions_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedSearchSuggestions_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "pageType",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "spellCheck",
            "storageKey": null,
            "args": null,
            "concreteType": "SpellcheckSuggestions",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "suggestions",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SpellcheckSuggestionsValues",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "name",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "count",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "uri",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '6f5560f3599e34348a2f2a6b8a79b5de';
export default node;
